﻿window.cObjetAvoirBonCadeauMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "avoir"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouvel avoir"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined' && objet.data.code != null && objet.data.code.length > 0) { txt = objet.data.code }
        else {
            var txt = "..."
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        if (!objet.data && !dataTemplate) {
            return $("<i class='fas fa-sack-xmark' class='avoir'></i>");
        } else {
            if (!dataTemplate) dataTemplate = objet.data
            switch (parseInt(dataTemplate.id_type_cheque)) {
                case 0:
                    return $("<i class='fas fa-sack-xmark' class='avoir'></i>");
                    break;
                case 1:
                    return $("<i class='fas fa-gift' class='avoir'></i>");
                    break;
            }
        }
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $Td = $("<td style='width:50%;font-weight:bold;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;'/>").appendTo($Tr).text(dataTemplate.keyguid)
        var $Td = $("<td style='width:25%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;'/>").appendTo($Tr).html(parseFloat(dataTemplate.mt).formatDisplay() + "€")
        var $Td = $("<td style='width:25%;font-weight:bold;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-align:right;'/>").appendTo($Tr)
        if (dataTemplate.date_utilisation) {
            $Td.html("UTILISÉ <span style='font-size:80%/'>(" + $.trim(dataTemplate.date_utilisation.toDateIlya()) + ")</span>")
            $Tr.closest(".divtemplate").addClass("texture_avoir_bon_cadeau_disable")
            $Td.css("color", "red")
        } else if (dataTemplate.date_purge) {
            $Td.html("PURGÉ <span style='font-size:80%/'>(" + $.trim(dataTemplate.date_purge.toDateIlya()) + ")</span>")
            $Tr.closest(".divtemplate").addClass("texture_avoir_bon_cadeau_disable")
            $Td.css("color", "red")
        } else if (dataTemplate.date_expiration < parametre.dateNow) {
            $Td.html("EXPIRÉ <span style='font-size:80%/'>(" + (dataTemplate.date_expiration ? $.trim(dataTemplate.date_expiration.toDateIlya()) : "") + ")</span>")
            $Tr.closest(".divtemplate").addClass("texture_avoir_bon_cadeau_disable")
            $Td.css("color", "red")
        } else {
            $Td.html("DISPONIBLE <span style='font-size:80%/'>(Expire " + (dataTemplate.date_expiration ? dataTemplate.date_expiration.toDateIlya() : "") + ")</span>")
            $Td.css("color", "green")
        }


        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var libDest = ""
        if (dataTemplate.lib_client) libDest = dataTemplate.lib_client
        //if (dataTemplate.nom_client && dataTemplate.nom_client.length > 0) libDest = dataTemplate.nom_client
        //if (dataTemplate.con_nom_client && dataTemplate.con_nom_client.length > 0) libDest += (libDest.length > 0 ? " " : "") + dataTemplate.con_nom_client
        //if (dataTemplate.con_prenom_client && dataTemplate.con_prenom_client.length > 0) libDest += (libDest.length > 0 ? " " : "") + dataTemplate.con_prenom_client
        //if (dataTemplate.ville_client && dataTemplate.ville_client.length > 0) libDest += (libDest.length > 0 ? " " : "") + dataTemplate.ville_client
        //if (dataTemplate.adresse_email_client && dataTemplate.adresse_email_client.length > 0) libDest += (libDest.length > 0 ? " " : "") + dataTemplate.adresse_email_client

        var $Td = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;'/>").appendTo($Tr).text(libDest)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.isUsed = function () {
        return objet.data.date_utilisation != null
    }
    this.isExpire = function () {
        return objet.data.date_expiration < parametre.dateNow
    }
    this.isPurge = function () {
        return objet.data.date_purge != null
    }
    this.isUtilisable = function () {
        return !(this.isUsed() || this.isExpire() || this.isPurge())
    }

    this.mPrint = function (formatPrint, showMt, funcEnd) {
        var base64 = ""
        var nomFichier =""
        if (objet.data.id_type_cheque == "0") {
            base64 = objet.bddRef.paraAppli.mGetPara("doccpt_cb_modele_print_avoir")
            nomFichier="AVOIR"
        } else {
            base64 = objet.bddRef.paraAppli.mGetPara("doccpt_cb_modele_print_boncadeau")
            nomFichier = "BONKDO"
        } 
        nomFichier += "_" + objet.data.keyguid

        objet.bddRef.mAjaxCall({
            command: "gethtmlfrombase64",
            database64: base64,
            id_societe: objet.data.id_societe
        }, function (data) {
            var html = data.html

            var $Div = $("<div/>").html(html)
            if (formatPrint == "80mm") $Div.css("font-family", "barlow condensed")
            if (!Me.isUtilisable()) $Div.css("text-decoration","line-through")
            var $DivPied = $("<div style='text-align:center;font-size:140%;'/>").appendTo($Div)
            $("<div style='text-align:center;'><span>" + (objet.data.id_type_cheque == "0" ? "AVOIR" : "BON CADEAU") + "</span> &bull; " + objet.data.keyguid + "</div>").appendTo($DivPied)
            if (showMt) {
                $("<div style='text-align:center;'>Montant: <b>" + parseFloat(objet.data.mt).formatDisplay() + "€</div></div>").appendTo($DivPied)
            } else {
                $("<div style='text-align:center;'>Montant: <b>***.**€</div></div>").appendTo($DivPied)
            }
            $("<div style='text-align:center;'>Expire le " + objet.data.date_expiration.toDDMMAAAA() + "</div>").appendTo($DivPied)
            if (!Me.isUtilisable()) $("<div style='text-align:center;color:red;'>Ce " + (objet.data.id_type_cheque == "0" ? "AVOIR" : "BON CADEAU") + " n'est plus utilisable</div>").appendTo($DivPied)
            $("<div style='text-align:center;'>&nbsp;</div>").appendTo($DivPied)

            var htmlFinal = $Div.prop("outerHTML");
            if (isInAppMobile() && formaPrint == "80mm") {
                var widthBase = "320"
                var widthZoom = widthBase * zoom
                var $DivCaisse = $("<div style='position:absolute;top:-100000px;left:-100000px;max-width:" + widthZoom + "px;min-width:" + widthZoom + "px;width:" + widthZoom + "px;' width='" + widthZoom + "px' border='0' cellspacing='0' cellpadding='0' align='center'/>").appendTo("body")
                $DivCaisse.html(htmlFinal)
                var imag = new cImage(objet.bddRef)
                imag.mGetImageFromHtml($DivCaisse, function (dataImgUrl) {
                    $DivCaisse.remove()
                    objet.bddRef.mAjaxCall({
                        command: "generepdfetimageurlprintapp",
                        dataurl: dataImgUrl,
                        html: htmlFinal,
                        html_pied: "",
                        type_format: formatPrint,
                        text_watermark: "",
                        externe: true,
                        nom_fichier: nomFichier
                    }, function (data) {
                        forcerFermetureNavigateur = true
                        window.open(data.urlbase, "_blank")
                        forcerFermetureNavigateur = false
                        if (typeof funcEnd != 'undefined') funcEnd()
                    }, function () {
                        jaugeDemarrage.mHide()
                    }, function () {
                        mNotify("Impossible d'imprimer le document", "error", 5000)
                    });
                })
            } else {
                var namePdfFile = (objet.data.id_type_cheque == "0" ? "AVOIR " : "BONKDO ") + objet.data.keyguid + ".pdf"
                var dataToBeSent = {
                    command: "generepdffromhtml",
                    nomFichier: namePdfFile,
                    html: htmlFinal,
                    html_pied: "",
                    externe: "1",
                    type_format: formatPrint,
                    text_watermark: "",
                    top: 200, right: 200, left: 200, bottom: 200
                }
                objet.bddRef.mAjaxCall(dataToBeSent, function (data) {
                    funcEnd(data.url)
                }, function () {
                    //jaugeDemarrage.mHide()
                }, function () {
                    mNotify("Impossible d'imprimer le document", "error", 5000)
                });
            }
        })
    }

}